import { defineField, defineType } from 'sanity'
import { PageBlockTypes, getBlockInsertMenuConfig } from '../pageBlocks'
import getPageInfo, { seoGroup } from '../objects/pageInfo'

export default defineType({
  title: 'Dynamic pages',
  name: 'dynamicPages',
  type: 'document',
  orderings: [
    {
      title: 'Title A-Z',
      name: 'titleAsc',
      by: [{field: 'pageInfo.title', direction: 'asc'}],
    },
  ],
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    {
      name: 'phases',
      title: 'Phases',
    },
    seoGroup,
  ],
  fields: [
    getPageInfo(),
    defineField({
      title: 'Disable header H1',
      name: 'disableHeaderH1',
      type: 'boolean',
      initialValue: false,
      group: 'content',
    }),
    defineField({
      title: 'Page blocks',
      name: 'pageBlocks',
      type: 'array',
      // Standard content section has no dates, so special-event blocks (which derive
      // their timing from phases) are excluded here — they live on phases only.
      of: PageBlockTypes,
      options: {
        insertMenu: getBlockInsertMenuConfig({ includeSpecialEvents: false }),
      },
      group: 'content',
      hidden: ({ document }) => document?.enablePhases === true,
    }),
    defineField({
      title: 'Enable time-based phases',
      name: 'enablePhases',
      type: 'boolean',
      initialValue: false,
      group: 'phases',
      description:
        'Switch to phased content mode for time-based page variations (e.g., countdown events)',
    }),
    defineField({
      title: 'Phases',
      name: 'phases',
      type: 'array',
      of: [{ type: 'pagePhase' }],
      group: 'phases',
      hidden: ({ document }) => document?.enablePhases !== true,
      description:
        'Each phase has a start date. The active phase is determined by the current time.',
    }),
  ],
  preview: {
    select: {
      name: 'pageInfo.title',
      enablePhases: 'enablePhases',
    },
    prepare({ name: title = 'New page', enablePhases }) {
      return {
        title,
        subtitle: enablePhases ? 'Phased content' : undefined,
      }
    },
  },
})